export function apply(errors, name, value, valid) {
    if (errors) {
        if (!valid) {
            if (!errors[name]) {
                errors[name] = value;
            }
        }
    }
}